<button *ngIf="isCitationVisible"
        [attr.aria-describedby]="ariaDescribedBy"
        [attr.aria-label]="'exportCitation' | translate"
        [ngClass]="{
          'small-button': smallButton,
          'button-labelled': !smallButton,
        }"
        aria-expanded="false"
        aria-haspopup="dialog"
        class="app-button options-toggle-button"
        data-automation-id="citation-mailing-button"
        [disabled]="disabled"
        tippy="{{ 'exportCitation' | translate }}"
        type="button"
        (click)="onCitation()"
>
  <fa-icon [icon]="quoteIcon" class="icon options-icon"></fa-icon>
  <span *ngIf="!smallButton" class="text" translate>citationMailingBtnLabel</span>
</button>
